@if (showLoading) {
  <app-loader-landing></app-loader-landing>
}
<router-outlet #outlet="outlet" (activate)="onActivate()"></router-outlet>